<template>
	<div class=" bg-gradient-to-t from-whiteDashboard to-white">
		<header>
			<div v-if="iconMenus" class="-mb-20 fixed">
				<nav class=" z-10 fixed">
					<label for="drop" class="toggle"
						><img
							src="../../../assets/dashboard/home/menu.svg"
							alt="menu"
							srcset=""
					/></label>
					<input type="checkbox" id="drop" />
					<ul
						class="menu text-left px-3 mt-2 py-4 bg-white rounded-lg border-gray-300 border"
					>
						<li>
							<router-link to="/" exact>
								<a href="#"
									><fai
										:icon="['fas', 'th-large']"
										class=" text-navyBlue mr-2"
									/>Home</a
								>
							</router-link>
						</li>
						<li>
							<router-link to="/comission" exact>
								<a href="#"
									><fai
										:icon="['fas', 'coins']"
										class=" text-navyBlue mr-2"
									/>Komisi</a
								>
							</router-link>
						</li>
						<li>
							<router-link to="/transaction" exact>
								<a href="#"
									><fai
										:icon="['fas', 'clipboard-list']"
										class=" text-navyBlue mr-2"
									/>Transaction</a
								>
							</router-link>
						</li>
						<li>
							<router-link to="/settings" exact>
								<a href="#"
									><fai
										:icon="['fas', 'cog']"
										class=" text-navyBlue mr-2"
									/>Settings</a
								>
							</router-link>
						</li>
					</ul>
				</nav>
			</div>
			<div class="mx-auto pb-4 pt-4">
				<img
					class="logo"
					src="../../../assets/static/svg/joinme.svg"
					alt=""
					srcset=""
				/>
			</div>
			<hr class="hr-text mb-4" />
			<div class="mx-auto">
				<div class="mx-3">
					<div class="inline text-navyBlue">
						<div class=" w-1/2 float-left">
							<div class="bg-gray-100  px-5 py-1 text-sm m-1 rounded-sm">
								Status Affiliasi:
								<span class="dot bg-red-500 ml-3 -mb-1"></span>
							</div>
						</div>
						<div class="w-1/2 float-right">
							<div class="bg-gray-100 px-5 py-1 text-sm m-1 rounded-sm">
								Status Vendor:
								<span class="dot bg-red-500 ml-3 -mb-1"></span>
							</div>
						</div>
					</div>
				</div>
			</div>
		</header>
		<!-- <div class="w-full">
			<p class="bg-lightYellow mt-16 text-sm text-white py-2 text-left px-5">
				Silahkan lakukan <b>verifikasi email</b> yang telah dikirim untuk
				menggunakan semua fitur!
			</p>
		</div> -->
	</div>
</template>

<script>
// import IconHome from "../../icons/menus/home.vue";

// import IconCommission from "../../icons/menus/commission.vue";
// import IconTransaction from "../../icons/menus/transaction.vue";
// import IconSettings from "../../icons/menus/settings.vue";
export default {
	name: "Header",
	components: {
		// "icon-home": IconHome,
		// "icon-commission": IconCommission,
		// "icon-transaction": IconTransaction,
		// "icon-settings": IconSettings,
	},
	data() {
		return {
			menus: false,
			iconMenus: false,
		};
	},
	methods: {
		toggleMenus: function() {
			this.menus = !this.menus;
		},
		hideMenus: function() {
			this.menus = false;
		},
	},
	created: function() {
		this.menus = false;
		this.iconMenus = false;
		if (this.$route.name == "wedding") {
			this.iconMenus = true;
		}
	},
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Karla:wght@400;500;600;700&display=swap");
p,
h1,
h2,
h3,
h4,
h5,
span,
button,
ul,
li {
	font-family: "Karla", sans-serif;
}
.dot {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.dot-active {
	height: 17px;
	width: 17px;
	border-radius: 50%;
	display: inline-block;
}
.ul-menu {
	width: 100%;
	max-width: 210px;
}

/* tambahan sini */

.toggle,
[id^="drop"] {
	display: none;
}

/* Styling the links */
nav a {
	display: block;
	padding: 5px 12px;
	font-size: 17px;
	text-decoration: none;
}

.toggle + a,
.menu {
	display: none;
	z-index: 10 !important;
	background: white;
}

/* Stylinf the toggle lable */
.toggle {
	display: block;
	padding: 14px 20px;
	text-decoration: none;
	border: none;
	max-width: 80px;
	margin-left: 15px;
}

/* Display Dropdown when clicked on Parent Lable */
[id^="drop"]:checked + ul {
	display: block;
}

/* Change menu item's width to 100% */
nav ul li {
	display: block;
	width: 100%;
}
</style>
